import React from "react";
import PropTypes from "prop-types";

import PrintDocumentInfoFabricator from "./printDocumentInfoFabricator";
import {IS_AS_WORK_ORDER, IS_DEALER_FLOW} from "../../../config";

export const getAddressFromObject = (userInfo) => {
  let displayAddress = "";
  [userInfo.city, userInfo.state, userInfo.postal].forEach(addressPart => { // 1) city 2) provence 3) postal
    if (addressPart) {
      if (displayAddress) {
        displayAddress += ", "
      }
      displayAddress += addressPart
    }
  });
  return displayAddress
}

const PrintDocumentInfo = (props) => {
  const {styles, userInfo, fabricatorData, assignQuotePopupCustomer, employeeSelected, messages, paymentState} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const customerName = IS_DEALER_FLOW && paymentState.shippingAddress && paymentState.shippingAddress.fullName
    ? paymentState.shippingAddress.fullName
    : assignQuotePopupCustomer
      ? assignQuotePopupCustomer.fullName
      : userInfo.firstName + (userInfo.lastName ? (" " + userInfo.lastName) : "");
  const customerEmail = IS_DEALER_FLOW
    ? ""
    : assignQuotePopupCustomer ? assignQuotePopupCustomer.email : userInfo.email || "";
  const customerPhone = IS_DEALER_FLOW ? "" : userInfo.phoneNumber
    ? userInfo.country && !userInfo.phoneNumber.includes(`+${userInfo.country.dialCode} `)
      ? `+${userInfo.country.dialCode} ${userInfo.phoneNumber}`
      : userInfo.phoneNumber
    : "";
  const mainAddress = IS_DEALER_FLOW ? paymentState.shippingAddress.address1 : userInfo.address1;
  const customerAddress = IS_DEALER_FLOW
    ? getAddressFromObject(paymentState.shippingAddress)
    : getAddressFromObject(userInfo);
  const customerHasShippingAddress = userInfo.shipping && (["address1", "city", "postal"].some(key => {
    return userInfo.shipping[key] && (userInfo[key] !== userInfo.shipping[key])
  }));
  let shippingAddress = "";
  if (customerHasShippingAddress) {
    shippingAddress = getAddressFromObject(userInfo.shipping);
  }
  const threeColumns = (employeeSelected || (customerHasShippingAddress && !fabricatorData.isCaesarStone))
    && !fabricatorData.isAmericanStandard && !IS_DEALER_FLOW;

  return (
    <View style={styles.main}>
      <View style={threeColumns ? [styles.section, styles.sectionLeft] : [styles.sectionTwo, styles.sectionLeft]}>
        <Text style={styles.mainTitle}>{messages["receipt.mainInfo.customerInformation"]}</Text>
        <Text style={styles.mainText}>{customerName}</Text>
        {mainAddress ? <Text style={styles.mainText}>{mainAddress}</Text> : null}
        {customerAddress ? <Text style={styles.mainText}>{customerAddress}</Text> : null}
        {customerEmail ? <Text style={[styles.mainText, styles.mainTextEmail]}>{customerEmail}</Text> : null}
        {customerPhone ? <Text style={styles.mainText}>{customerPhone}</Text> : null}
      </View>
      {threeColumns ? (
        <View style={[styles.section, styles.sectionCenter]}>
          {!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
            ? <Text style={styles.mainTitle}>{messages["receipt.mainInfo.billingAddress"]}</Text>
            : null}
          {!fabricatorData.isCaesarStone && userInfo.shipping.address1
            ? <Text style={styles.mainText}>{userInfo.shipping.address1}</Text>
            : null}
          {!fabricatorData.isCaesarStone && shippingAddress
            ? <Text style={styles.mainText}>{shippingAddress}</Text>
            : null}
          {employeeSelected ? (
            <Text style={!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
              ? [styles.mainTitle, styles.mainTextEmail] : styles.mainTitle}>
              {messages["receipt.mainInfo.salesPerson"]}
            </Text>
          ) : null}
          {employeeSelected ? <Text style={styles.mainText}>{employeeSelected.fullName}</Text> : null}
        </View>
      ) : null}
      {IS_AS_WORK_ORDER ? null : <PrintDocumentInfoFabricator fabricatorData={fabricatorData}
                                                              threeColumns={!!threeColumns}
                                                              styles={styles}
                                                              messages={messages}/>}
    </View>
  )
};

PrintDocumentInfo.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentInfo
